import { LoginModalOpenEventProps } from 'Shared/components/design/loginModal/models/eventModels';
import { dispatchEvent } from 'Shared/services/eventsInterface';
import { MF_EVENTS } from "Shared/services/routingService";

export const dispatchLoginModalOpenEvent = (ev: LoginModalOpenEventProps): void => {
  dispatchEvent(MF_EVENTS.loginModal.open, ev);
};